import { createFileRoute } from '@tanstack/react-router'
import { JobDetailPage } from '@/features/smart-search/job-detail'

function RouteComponent() {
  const { jobId, searchId } = Route.useParams()
  return <JobDetailPage jobId={jobId} candidateSearchId={searchId} ctx={{ kind: 'custom' }} />
}

export const Route = createFileRoute(
  '/_authenticated/company-jobs/custom-job/$jobId/smart-search/$searchId/'
)({
  component: RouteComponent,
})
